import { AiccSandboxBaseScope } from "constants/aiccPromptSandbox";
import { AiccSandboxInputs } from "types/model/aiccPromptSandbox";
import { sandboxInputsRequest } from "./Variables/variableInputs";

export interface SandboxRequestBase {
  base_scope: AiccSandboxBaseScope;
  variables?: Record<string, string>;
}

export const sandboxRequestBase = (inputs: AiccSandboxInputs, baseScope: AiccSandboxBaseScope): SandboxRequestBase => ({
  base_scope: baseScope,
  ...sandboxInputsRequest(inputs),
});
